import { Message } from 'element-ui'
import api from '../apiConfig/api'
import util from '../util/util'
import constant from '../constant'
import qs from 'qs'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import hzTopy from 'js-pinyin/index'
import SparkMD5 from 'spark-md5'

export default [
    {
        name: "$msg",
        val: Message,
    },
    {
        name: "$api",
        val: api,
    },
    {
        name: "$util",
        val: util,
    },
    {
        name: "$qs",
        val: qs,
    },
    {
        name: "$CONSTANT",
        val: constant,
    },
    {
        name: "$FileSaver",
        val: FileSaver,
    },
    {
        name: "$XLSX",
        val: XLSX,
    },
    {
        name: "$hzTopy",
        val: hzTopy,
    },
    {
        name: "$SparkMD5",
        val: SparkMD5,
    },
    {
        name: "moneyFormat",
        val: (val) => {
            let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
            if (val) {
                if (reg.test(val)) {
                    return val
                } else {
                    Message.error('请输入正确金额')
                    return 0
                }
            }
        }
    },
    {
        name: "numFormat",
        val: (val) => {
            // let reg = /^(((\d|[1-9]\d)(\.\d{1,2})?)|100|100.0|100.00)$/
            let reg = /^^[1-9]\d*$/
            if (val) {
                if (reg.test(val)) {
                    return val
                } else {
                    Message.error('请输入正整数')
                    return 0
                }
            }
        }
    },{
        name: "moneyFormat1",
        val: (val) => {
// 任意正整数，正小数（小数位不超过2位）
            let reg=/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
            if (val) {
                if (reg.test(val)) {
                    return val
                } else {
                // Message.error('请输入正确金额格式：任意正整数，正小数（小数位不超过2位）')
                Message.error('请输入正确格式：任意正整数，正小数（小数位不超过2位）')

                    return 0
                }
            }
        }
    },{
        name: "moneyFormata",
        val: (val) => {

            // 任意正整数，正小数（小数位不超过2位）
            let reg=/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
            if (val) {
                if (reg.test(val)) {
                    return val
                } else {
                // Message.error('请输入正确金额格式：任意正整数，正小数（小数位不超过2位）')
                Message.error('aaaa请输入正确格式：任意正整数，正小数（小数位不超过2位）')

                    return 0
                }
            }
        }
    }
    
]



// WEBPACK FOOTER //
// ./src/common/prototype.js